
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[category]/[...slug]",
      function () {
        return require("private-next-pages/blog/[category]/[...slug].js");
      }
    ]);
  